<div class="flex-container" *ngIf="data">
<div class="component-container default" [class]="controlAction">
  <div class="status-msg" *ngIf="broadcast?.config?.statusMsg && !simple">{{ broadcast?.config?.statusMsg }}</div>
  <div class="score-panel" [class.simple]="simple">
    <div class="logo" *ngIf="!simple && !preview">
      <img [src]="broadcast?.config?.smallLogoUrl" alt="league-logo">
    </div>
    <div class="team-score">
      <div class="team away">
        <div class="name" [style.background-color]="utilService.getTeamBgrByGuid(broadcast?.config?.awayConfig?.id, broadcast)">
          {{broadcast?.config?.awayConfig?.shortName}}
        </div>
        <div class="score">{{data.away}}</div>
      </div>
      <div class="team home">
        <div class="name" [style.background-color]="utilService.getTeamBgrByGuid(broadcast?.config?.homeConfig?.id, broadcast)">
          {{broadcast?.config?.homeConfig?.shortName}}
        </div>
        <div class="score">{{data.home}}</div>
      </div>
    </div>
    <div class="game-stats-wrapper">
      <div class="game-stats" [class.show-stats]="data.inningPart === 'T' || data.inningPart === 'B' || simple || preview">
        <div class="inning" [class.bottom]="data.inningPart === 'B'">
          <mat-icon class="top" *ngIf="data.inningPart === 'T' || data.inningPart === 'B'">{{ data.inningPart === 'B' ? 'chevron_right' : 'play_arrow' }}</mat-icon>
          <span *ngIf="!preview">{{data.inningPart != 'F' ? data?.inning : 'F'}}</span>
          <span *ngIf="preview">{{data.inningPart}}{{data.inning}}</span>
          <mat-icon class="bottom" *ngIf="data.inningPart === 'T' || data.inningPart === 'B'">{{ data.inningPart === 'B' ? 'play_arrow' : 'chevron_right' }}</mat-icon>
        </div>
        <div class="stats" *ngIf="((data.inningPart === 'T' || data.inningPart === 'B') && !broadcast?.resettingManualData) || preview">
          <div class="baseline">
            <div class="strikes" *ngIf="!simple">{{data.balls}} - {{data.strikes}}</div>
            <div class="bases">
              <div class="base first-base" [class.on-base]="data.first"></div>
              <div class="base second-base" [class.on-base]="data.second"></div>
              <div class="base third-base" [class.on-base]="data.third"></div>
            </div>
          </div>
          <div class="pitchline">
            <div class="outs">
              <div class="dot" [class.active]="data.outs > 0"></div>
              <div class="dot" [class.active]="data.outs > 1"></div>
            </div>
            <ng-container *ngIf="!broadcast?.radarSpeed && !simple">
              <div class="pitches" *ngIf="data.inningPart === 'T' && data.homePitches">P: {{data.homePitches}}</div>
              <div class="pitches" *ngIf="data.inningPart === 'B' && data.awayPitches">P: {{data.awayPitches}}</div>
            </ng-container>
            <ng-container *ngIf="broadcast?.radarSpeed && !simple">
              <div class="speed">
                {{broadcast.radarSpeed}}
                <span class="unites">{{broadcast.config.unites}}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</div>
